<template>
  <v-container>
    <v-dialog
      persistent
      overlay-opacity="0.5"
      v-model="leaveApplicationReportDialog.open"
      width="80%"
    >
      <v-card tile>
        <v-btn
          icon
          :style="{
            float: 'right',
            color: '#000',
            marginTop: '1%',
          }"
          style="position: absolute; right: 1em"
          @click="leaveApplicationReportDialog = false"
        >
          <v-icon size="30">mdi-close</v-icon>
        </v-btn>
        <v-card-title> Leave Application Report </v-card-title>
        <v-card-text>
          <div id="leaveApplicationReport">
            <pdf
              ref="leaveApplicationReport"
              @click="PrintElem"
              :src="`data:application/pdf;base64,${leaveApplicationReportDialog.leaveApplicationReport}`"
            ></pdf>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="PrintElem('leaveApplicationReport')"
            style="position: fixed; right: 12%; bottom: 10%"
            color="primary"
            rounded
          >
            <v-icon class="mx-3">print</v-icon>
            Print
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import pdf from "vue-pdf";
export default {
  name: "LeaveApplicationReport",
  components: { pdf },
  data: () => ({}),
  computed: {
    ...mapState({}),
    leaveApplicationReportDialog: {
      get() {
        return this.$store.state.leave.leaveApplicationReportDialog;
      },
      set(value) {
        this.$store.commit("leave/SET_LEAVE_APPLICATION_REPORT", {
          open: value,
          leaveApplicationReport: "",
        });
      },
    },
  },
  methods: {
    ...mapActions({}),
    PrintElem() {
      this.$refs.leaveApplicationReport.print();
    },
  },
};
</script>
